import { type MouseEvent, type ReactElement, useState } from "react"
import { createRoot } from "react-dom/client"

type EmailVerificationProps = {
  resendUrl: string
}

function EmailVerificationStatus({ resendUrl }: EmailVerificationProps): ReactElement {
  const [hidden, setHidden] = useState(false)

  function handleClick(_event: MouseEvent<HTMLAnchorElement>): void {
    setHidden(true)
  }

  if (hidden) return <></>

  return (
    <>
      {" "}
      <a
        href={resendUrl}
        className="settings__verification-link"
        onClick={handleClick}
      >
        Resend verification email?
      </a>
    </>
  )
}

function mountSettingsApps(): void {
  document.querySelectorAll<HTMLElement>("[data-settings-email-verification-app]").forEach((el) => {
    const resendUrl = el.dataset.resendUrl ?? ""
    if (!resendUrl) return

    createRoot(el).render(<EmailVerificationStatus resendUrl={resendUrl} />)
  })
}

mountSettingsApps()
